<template>
	<!-- 客户管理 -->
	<div class="saleCustomerManagement">
		<div class="public_Spacing customerManagementPC">
			<div class="pulbic_oparetionBlock">
				<div class="public_criteriaRange customerManagementPC-select">
					<div class="public_oparetionBlock_Menu">
						<label class="public_lbSty">客户名称：</label>
						<div class="el-select public_optionSty">
							<div class="el-input el-input--suffix">
								<input style="padding-right: 10px;" maxlength="7"
									class="el-input__inner pulic_carNumber" type="text" placeholder="请输入客户名称"
									v-model="cusQueryName" />
							</div>
						</div>
					</div>
					<div class="public_oparetionBlock_Menu">
						<label class="public_lbSty">手机号：</label>
						<div class="el-select public_optionSty">
							<div class="el-input el-input--suffix">
								<input maxlength="11" class="el-input__inner pulic_carNumber" type="text"
									placeholder="请输入手机号" v-model="cusQueryiphone" />
							</div>
						</div>
					</div>
					<div class="public_oparetionBlock_Menu">
						<label class="public_lbSty">客户等级：</label>
						<el-select class="public_optionSty dropDown_Define" v-model="khdj" placeholder="请选择">
							<el-option v-for="item in khdjOperation" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</div>
					<div class="public_oparetionBlock_Menu">
						<label class="public_lbSty">客户星级：</label>
						<el-select class="public_optionSty dropDown_Define" v-model="khxj" placeholder="请选择">
							<el-option v-for="item in khxjOperation" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</div>
				</div>
				<div class="customerManagementPC-btn public_operatBtn" style="margin-left: 0px;">
					<button class="public_saleWater_xinzeng pulic_cursor pulic_cursor"
						@click="queryWayTypeQuery(),saleWaterDetails=true" v-shiroHiden="solelist" id="充值类型"><i
							class="iconfont icon-chaxun"></i>充值类型</button>
					<el-button class="public_saleWater_chaxun" type="primary" v-shiroHiden="solelist" id="查询"
						@click="querycusList()">
						<i class="iconfont icon-chaxun"></i>查询
					</el-button>
					<el-button class="public_saleWater_xinzeng" type="primary" v-shiroHiden="solelist" id="新增"
						@click="cusADD">
						<i class="iconfont icon-tianjia1"></i>新增
					</el-button>
					<el-button class="public_saleWater_daochu" type="primary" v-if="preferentialType==1"
						v-shiroHiden="solelist" id="客户等级管理" @click="customerManagement=true,customerManagementQuery()">
						客户等级管理
					</el-button>
					<el-button class="public_saleWater_chaxun" type="primary" v-shiroHiden="solelist" id="查询"
						@click="querycusList(1)">
						<i class="iconfont icon-chaxun"></i>查询全部
					</el-button>
					<el-button class="public_saleWater_xinzeng" type="primary" v-shiroHiden="solelist" id="等级冻结设置"
						@click="freezeSetClick()">
						<i class="iconfont icon-shezhi"></i>等级冻结设置
					</el-button>

					<!-- <el-button class="public_saleWater_quanping" type="primary" :disabled="quanpDisabled" @click="fullScreen">
						<i class="iconfont icon-tuichuquanping1"></i>全屏
					</el-button> -->
				</div>
			</div>
			<div class="customerManagementPC-table pulbic_oparetionBlock pulbic_table_container">
				<el-table :data="tableData" @sort-change="onSortChange" height="580" style="width: 100%" stripe
					class="public_tableColumn" :header-cell-style="{color:'rgba(51,51,51,1)','font-weight':'bold'}">
					<el-table-column prop="ORMTB410CA00" label="客户名称">
						<template slot-scope="scope">
							<p>
								<span>{{scope.row.ORMTB410CA00}}</span>
							</p>
							<p style="color: #999;">
								<span>{{scope.row.ORMTB410CA02}}</span>
							</p>

						</template>
					</el-table-column>
					<!-- <el-table-column prop="ORMTB410CA00" label="客户身份">
						<template slot-scope="scope">
							<p style="color: #FFCC00;" v-if="scope.row.ORMTB410CB03 =='1'">
								<span>发单人</span>
							</p>
							<p style="color: #FF6600;" v-if="scope.row.ORMTB410CB04 =='1'">
								<span>车主</span>
							</p>
							<p v-else>
								<span>普通用户</span>
							</p>
						</template>
					</el-table-column> -->
					<!-- <el-table-column prop="ORMTB410CA02" label="手机号"></el-table-column> -->
					<!-- <el-table-column prop="ORMTB410CA03" sortable label="现金"></el-table-column> -->
				<!-- 	<el-table-column prop="ORMTB410CA04" sortable label="冻结金额" width="110"></el-table-column>
					<el-table-column prop="ORMTB410CA05" sortable label="可提现金额" width="200"></el-table-column> -->
					<el-table-column v-if="preferentialType==1" prop="ORMTB410CA06" sortable label="客户等级">
						<template slot-scope="scope">
							<p>
								<span>{{scope.row.ORMTB410CA06Name}}</span>
							</p>
						</template>
					</el-table-column>
					<!-- <el-table-column prop="ORMTB410CB02" sortable label="客户星级" width="110">
						<template slot-scope="scope">
							<p v-if="scope.row.ORMTB410CB02>=1">
								<span>V{{scope.row.ORMTB410CB02}}</span>
							</p>
						</template>
					</el-table-column> -->
					<!-- <el-table-column prop="recharge" sortable label="累计充值" ></el-table-column>
					<el-table-column prop="consume" sortable label="累计消费"></el-table-column> -->
					<el-table-column prop="consume" sortable label="可开票额度"></el-table-column>
					<el-table-column prop="consume" sortable label="已开票额度"></el-table-column>
					<el-table-column prop="consume" sortable label="剩余开票额度"></el-table-column>
					<!-- <el-table-column prop="withdraw" sortable label="累计提现" width="110"></el-table-column> -->
					<!-- <el-table-column prop="score" sortable label="积分"></el-table-column> -->
					<el-table-column label="操作" width="400">
						<template slot-scope="scope">
							<div class="customerManagementPC-table-btn">
								<!-- <el-button @click="updateUserStatus(scope.row)" v-if="scope.row.ORMTB410CB00==1"
									type="error" class="public_icon_xiugai public_icon_width" size="small"
									style="color: red!important">禁用</el-button>
								<el-button @click="updateUserStatus(scope.row)" v-if="scope.row.ORMTB410CB00==0"
									type="primary" class="public_icon_xiugai public_icon_width" size="small">启用
								</el-button>
								<el-button @click="updateUserLimitStatus(scope.row)" v-if="scope.row.ORMTB410CB01==0"
									type="error" class="public_icon_xiugai public_icon_width" size="small"
									style="color: red!important">限制下单</el-button>
								<el-button @click="updateUserLimitStatus(scope.row)" v-if="scope.row.ORMTB410CB01==1"
									type="primary" class="public_icon_xiugai public_icon_width" size="small">解除限制
								</el-button> -->
								
								<el-dropdown>
									<span class="el-dropdown-link public_icon_qiyong">
										财务<i class="el-icon-arrow-down el-icon--right"></i>
									</span>
									<el-dropdown-menu slot="dropdown">
										<el-dropdown-item>
											<el-button class="public_icon_chongzhi public_icon_width public_icon_margin"
												type="primary" size="small" @click="czClick(scope.row)"
												v-shiroHiden="solelist" id="充值">充值</el-button>
										</el-dropdown-item>
										<el-dropdown-item>
											<el-button
												class="public_icon_hongchongred public_icon_width public_icon_margin"
												type="danger" size="small" @click="HCclick(scope.row)" id="红冲">红冲
											</el-button>
										</el-dropdown-item>
										<el-dropdown-item>
											<el-button
												class="public_icon_chongzhi  public_icon_margin recharge-discount-width"
												type="primary" size="small" @click="CZrecordClick(scope.row)"
												v-shiroHiden="solelist" id="充值记录">充值优惠记录</el-button>
										</el-dropdown-item>
									</el-dropdown-menu>
								</el-dropdown>
								
								
								
								<el-button type="primary" class="public_icon_xiugai public_icon_width"
									v-shiroHiden="solelist" id="修改" size="small" @click="upuserClick(scope.row)">修改
								</el-button>
								<el-dropdown style="padding-left: 20px;" v-shiroHiden="solelist" id="设置">
									<span class="el-dropdown-link public_icon_qiyong">
										设置<i class="el-icon-arrow-down el-icon--right"></i>
									</span>
									<el-dropdown-menu slot="dropdown">
										<el-dropdown-item>
											<el-button @click="updateUserLimitStatus(scope.row)" v-if="scope.row.ORMTB410CB01==0"
												type="error" class="public_icon_xiugai public_icon_width" size="small"
												style="color: red!important">限制下单</el-button>
											<el-button @click="updateUserLimitStatus(scope.row)" v-if="scope.row.ORMTB410CB01==1"
												type="primary" class="public_icon_xiugai public_icon_width" size="small">解除限制
											</el-button>
										</el-dropdown-item>
										<el-dropdown-item>
											<el-button @click="updateUserStatus(scope.row)" v-if="scope.row.ORMTB410CB00==1"
												type="error" class="public_icon_xiugai public_icon_width" size="small"
												style="color: red!important">禁用</el-button>
											<el-button @click="updateUserStatus(scope.row)" v-if="scope.row.ORMTB410CB00==0"
												type="primary" class="public_icon_xiugai public_icon_width" size="small">启用
											</el-button>
										</el-dropdown-item>
										<el-dropdown-item>
											<el-button type="primary" style="color: red!important" class="public_icon_xiugai public_icon_width"
												 size="small" @click="upDJSetuserClick(scope.row)">冻结设置
											</el-button>
										</el-dropdown-item>
									</el-dropdown-menu>
								</el-dropdown>
								
							</div>
						</template>
					</el-table-column>
				</el-table>
				<div class="customerManagementPC-page">
					<span style="font-size: 14px;color:#606266;" v-if="flag =='1'">共{{count}}条</span>
					<el-pagination v-if="!flag" @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page.sync="currentPage" :page-sizes="[10, 20, 30, 40]"
						layout="total, sizes,prev, pager, next, jumper" :page-size="pagesize" :total="count"></el-pagination>
				</div>
			</div>

			<div class="public-dialog">
				<el-dialog title="新增客户" :visible.sync="cusInsertShow" width="30%" @close="cusInsertClose"
					:closeOnClickModal='false' append-to-body custom-class="sales-bill-dialog">
					<div class="customerManagementPC-add-customer">
						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">客户名称:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<input type="text" v-model="cusInsertObj.ORMTB410CA00" maxlength="100" />
							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div>
						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">简称:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<input type="text" v-model="cusInsertObj.ORMTB410CA01" maxlength="20" />
							</div>
							<div class="customerManagementPC-add-customer-li-type"></div>
						</div>
						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">联系电话:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<input type="text" v-model="cusInsertObj.ORMTB410CA02" maxlength="11" />
							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div>
						<div class="customerManagementPC-add-customer-li" v-if="preferentialType==1">
							<div class="customerManagementPC-add-customer-li-name">客户等级:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<el-select v-model="cusInsertObj.ORMTB410CA06" placeholder="请选择">
									<el-option v-for="item in customerManagementList" :key="item.SETTB206CA00"
										:label="item.SETTB206CA01" :value="item.SETTB206CA00">
									</el-option>
								</el-select>
							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div>
						<div class="customerManagementPC-add-customer-btn">
							<el-button type="primary" @click="cusInsertServe">保存</el-button>
							<el-button type="info" @click="cusInsertShow=false">取消</el-button>
						</div>
					</div>
				</el-dialog>
			</div>

			<div class="public-dialog">
				<el-dialog title="用户下单等级冻结金额设置" :visible.sync="freezeInsertShow" width="30%" @close="cusInsertClose"
					:closeOnClickModal='false' append-to-body custom-class="sales-bill-dialog">
					<ul class="levelmang-table">
						<li class="levelmang-table-head">
							<div class="levelmang-table-JB">
								级别
							</div>
							<div class="levelmang-table-KJ">
								冻结倍数
							</div>
						</li>
						<li class="levelmang-table-li" v-for="(item,index) in tableDataGradePre" :key="index">

							<div class="levelmang-table-li-tab">
								<div class="levelmang-table-li-tab-li"
									>
									<div class="levelmang-table-JB">
										{{item.ORMTB405CA02}}
									</div>
									<div class="levelmang-table-KJ public-chech-details">
										<el-input-number :precision="1" :step="1" :min="0" :max="100"
											v-model="item.ORMTB405CA01"></el-input-number>倍
									</div>
								</div>
							</div>
						</li>
					</ul>
					<div class="customerManagementPC-add-customer-btn">
						<el-button type="primary" @click="cusDJSetInsertServe">保存</el-button>
						<el-button type="info" @click="freezeInsertShow=false">取消</el-button>
					</div>
				</el-dialog>
			</div>
			
			<div class="public-dialog">
				<el-dialog title="用户下单冻结金额设置" :visible.sync="cusUDJSetpdateShow" width="30%" @close="upCusClose"
					:closeOnClickModal='false' append-to-body custom-class="sales-bill-dialog">
					<div class="customerManagementPC-add-customer">
						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">客户名称:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<input type="text" disabled v-model="cusDJSetObj.ORMTB410CA00" maxlength="100" />
							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div>
						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">联系电话:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<input type="text" disabled v-model="cusDJSetObj.ORMTB410CA02" maxlength="11" />
							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div>
						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">客户等级:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<input type="text" disabled v-model="cusDJSetObj.ORMTB410CA06Name" maxlength="100" />
							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div>
						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">冻结倍数:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<el-input-number :controls="false" :precision="1" :step="1" :min="0" :max="100"
									v-model="cusDJSetObj.ORMTB410CB07"></el-input-number>
								<!-- <input type="number" v-model="cusDJSetObj.DJBSNum" maxlength="100" /> -->
							</div>
							<div class="customerManagementPC-add-customer-li-type">倍*必填*</div>
						</div>
						<div class="customerManagementPC-add-customer-btn">
							<el-button type="primary" @click="cusDJSetdateServe">保存</el-button>
							<el-button type="info" @click="cusUDJSetpdateShow=false">取消</el-button>
						</div>
					</div>
				</el-dialog>
			</div>

			<div class="public-dialog">
				<el-dialog title="编辑客户" :visible.sync="cusUpdateShow" width="30%" @close="upCusClose"
					:closeOnClickModal='false' append-to-body custom-class="sales-bill-dialog">
					<div class="customerManagementPC-add-customer">
						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">客户名称:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<input type="text" v-model="cusUpdateObj.ORMTB410CA00" maxlength="100" />
							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div>
						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">简称:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<input type="text" v-model="cusUpdateObj.ORMTB410CA01" maxlength="20" />
							</div>
							<div class="customerManagementPC-add-customer-li-type"></div>
						</div>
						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">联系电话:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<input type="text" v-model="cusUpdateObj.ORMTB410CA02" maxlength="11" />
							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div>
						<div class="customerManagementPC-add-customer-li" v-if="preferentialType==1">
							<div class="customerManagementPC-add-customer-li-name">客户等级:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<el-select v-model="cusUpdateObj.ORMTB410CA06" placeholder="请选择">
									<el-option v-for="item in customerManagementList" :key="item.SETTB206CA00"
										:label="item.SETTB206CA01" :value="item.SETTB206CA00">
									</el-option>
								</el-select>
							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div>
						<div class="customerManagementPC-add-customer-btn">
							<el-button type="primary" @click="cusUpdateServe">保存</el-button>
							<el-button type="info" @click="cusUpdateShow=false">取消</el-button>
						</div>
					</div>
				</el-dialog>
			</div>
			
			
			
			<div class="public-dialog">
				<el-dialog title="充值类型管理" :visible.sync="saleWaterDetails" width="60%" @close="saleWaterDetailsclose"
					:closeOnClickModal='false' append-to-body custom-class="sales-bill-dialog">
					<div class="salesWatersStatisticsPC-saleWaterDetails">
						<div class="salesWatersStatisticsPC-saleWaterDetails-btn public_operatBtn"
							style="margin-left:0;">
							<button class="public_saleWater_xinzeng pulic_cursor" @click="rechargeTypeAdd"><i
									class="iconfont icon-tianjia1"></i>新增</button>
						</div>
						<div class="salesWatersStatisticsPC-saleWaterDetails-table pulbic_table_container">
							<el-table :data="tableDataDetails" style="width: 100%" stripe class="public_tableColumn"
								:header-cell-style="{'font-family':'Microsoft YaHei','font-weight':'bold',color:'rgba(51,51,51,1)'}">
								<el-table-column prop="SETTB206CA01" label="充值类型名称">
								</el-table-column>
								<el-table-column prop="SETTB206CC01" label="创建人">
								</el-table-column>
								<el-table-column prop="SETTB206CC00" label="创建时间">
								</el-table-column>
								<el-table-column label="操作">
									<template slot-scope="scope">
										<div class="CustomertopUpDig-content-table-btn">
											<el-button class="public_icon_xiugai public_icon_width public_icon_margin"
												type="primary" size="small" @click="rechargeTypeModify(scope.row)">修改
											</el-button>
											<el-button class="public_icon_jinyong public_icon_width" type="primary"
												size="small" v-if="scope.row.SETTB206CA02==1"
												@click="disableCus(scope.row,0)">禁用</el-button>
											<el-button class="public_icon_qiyong public_icon_width" type="primary"
												size="small" v-if="scope.row.SETTB206CA02==0"
												@click="disableCus(scope.row,1)">启用</el-button>
										</div>
									</template>
								</el-table-column>
							</el-table>
						</div>
						<div class="billOperationRecord-page">
							<el-pagination @size-change="handleSizeChange1" @current-change="handleCurrentChange1"
								:current-page.sync="currentPage1" :page-sizes="[10, 20, 30, 40]"
								:page-size="detailsPageLimit" layout="total,sizes, prev, pager, next, jumper"
								:total="detailsCount">
							</el-pagination>
						</div>
					</div>
				</el-dialog>
			</div>
			<div class="public-dialog">
				<el-dialog title="客户等级管理" :visible.sync="customerManagement" width="60%" :closeOnClickModal='false' append-to-body custom-class="sales-bill-dialog">
					<div class="salesWatersStatisticsPC-saleWaterDetails">
						<div class="salesWatersStatisticsPC-saleWaterDetails-btn public_operatBtn"
							style="margin-left:0;">
							<button class="public_saleWater_xinzeng pulic_cursor" @click="customerManagementAdd=true"><i
									class="iconfont icon-tianjia1"></i>新增</button>
						</div>
						<div class="salesWatersStatisticsPC-saleWaterDetails-table pulbic_table_container">
							<el-table :data="customerManagementList" style="width: 100%" stripe
								class="public_tableColumn"
								:header-cell-style="{'font-family':'Microsoft YaHei','font-weight':'bold',color:'rgba(51,51,51,1)'}">
								<el-table-column prop="SETTB206CA01" label="等级名称">
								</el-table-column>
								<el-table-column prop="SETTB206CC01" label="创建人">
								</el-table-column>
								<el-table-column prop="SETTB206CC00" label="创建时间">
								</el-table-column>
								<el-table-column label="操作">
									<template slot-scope="scope">
										<div class="CustomertopUpDig-content-table-btn">
											<el-button class="public_icon_xiugai public_icon_width public_icon_margin"
												type="primary" size="small" @click="cusUpdataClick(scope.row)">修改
											</el-button>
										</div>
									</template>
								</el-table-column>
							</el-table>
						</div>
					</div>
				</el-dialog>
			</div>
			<div class="public-dialog">
				<el-dialog title="新增" :visible.sync="customerManagementAdd" width="30%"
					@close="customerManagementAddName=''" :closeOnClickModal='false' append-to-body custom-class="sales-bill-dialog">
					<div class="CustomerfillingDig-tab">
						<div class="rechargeType-tab-li">
							<div class="rechargeType-tab-li-text">等级名称：</div>
							<div class="rechargeType-tab-li-ipt">
								<input v-model="customerManagementAddName" type="text" maxlength="40">
							</div>
							<div class="rechargeType-tab-li-b">*必填*</div>
						</div>
						<div class="CustomerfillingDig-tab-btn rechargeType-tab-btn">
							<el-button type="primary" @click="customerManagementAddServe">保存</el-button>
							<el-button type="warning" @click="customerManagementAdd=false">取消</el-button>
						</div>
					</div>
				</el-dialog>
			</div>
			<!-- 客户等级修改 -->
			<div class="public-dialog">
				<el-dialog title="修改" :visible.sync="customerManagementUpdate" width="30%"
					@close="customerManagemenUPObj=''" :closeOnClickModal='false' append-to-body custom-class="sales-bill-dialog">
					<div class="CustomerfillingDig-tab">
						<div class="rechargeType-tab-li">
							<div class="rechargeType-tab-li-text">等级名称：</div>
							<div class="rechargeType-tab-li-ipt">
								<input v-model="customerManagemenUPObj.SETTB206CA01" type="text">
							</div>
							<div class="rechargeType-tab-li-b">*必填*</div>
						</div>
						<div class="CustomerfillingDig-tab-btn rechargeType-tab-btn">
							<el-button type="primary" @click="customerManagementUpdateServe">保存</el-button>
							<el-button type="warning" @click="customerManagementUpdate=false">取消</el-button>
						</div>
					</div>
				</el-dialog>
			</div>
			<!-- 充值类型新增 rechargeTypeModifyDig-->
			<div class="public-dialog">
				<el-dialog title="新增" :visible.sync="rechargeTypeDig" width="30%" @close="rechargeTypeName=''"
					:closeOnClickModal='false' append-to-body custom-class="sales-bill-dialog">
					<div class="CustomerfillingDig-tab">
						<div class="rechargeType-tab-li">
							<div class="rechargeType-tab-li-text">充值类型名称：</div>
							<div class="rechargeType-tab-li-ipt">
								<input v-model="rechargeTypeName" type="text" maxlength="40">
							</div>
							<div class="rechargeType-tab-li-b">*必填*</div>
						</div>
						<div class="CustomerfillingDig-tab-btn rechargeType-tab-btn">
							<el-button type="primary" @click="rechaTypePreser">保存</el-button>
							<el-button type="warning" @click="rechargeTypeDig=false">取消</el-button>
						</div>
					</div>
				</el-dialog>
			</div>
			<!-- 充值类型修改 -->
			<div class="public-dialog">
				<el-dialog title="修改" :visible.sync="rechargeTypeModifyDig" width="30%" @close="rechargeTypeModifyClose"
					:closeOnClickModal='false' append-to-body custom-class="sales-bill-dialog">
					<div class="CustomerfillingDig-tab">
						<div class="rechargeType-tab-li">
							<div class="rechargeType-tab-li-text">充值类型名称：</div>
							<div class="rechargeType-tab-li-ipt">
								<input v-model="rechargeTypeUpOBJ.SETTB206CA01" type="text">
							</div>
							<div class="rechargeType-tab-li-b">*必填*</div>
						</div>
						<div class="CustomerfillingDig-tab-btn rechargeType-tab-btn">
							<el-button type="primary" @click="rechaTypePreserModify">保存</el-button>
							<el-button type="warning" @click="rechargeTypeModifyDig=false">取消</el-button>
						</div>
					</div>
				</el-dialog>
			</div>
			<!--  -->
			<div class="public-dialog">
				<el-dialog title="充值" :visible.sync="CustomerfillingDig" width="40%"
					@close="CZmoney='',amountCapitalText=''" :closeOnClickModal='false' append-to-body custom-class="sales-bill-dialog">
					<div style="max-height: 500px;overflow-y: auto;">
						<div class="CustomerfillingDig-tab">
							<div class="CustomerfillingDig-tab-li">
								<div class="CustomerfillingDig-tab-li-text">客户名称：</div>
								<div class="CustomerfillingDig-tab-li-ipt">{{cusUpdateObj.ORMTB410CA00}}</div>
								<div class="CustomerfillingDig-tab-li-b"></div>
							</div>
							<div class="CustomerfillingDig-tab-li">
								<div class="CustomerfillingDig-tab-li-text">充值类型：</div>
								<div class="CustomerfillingDig-tab-li-ipt">
									<el-select v-model="RechargetypeValue" placeholder="请选择">
										<el-option v-for="item in RechargetypeOptions" :key="item.SETTB206CA01"
											:label="item.SETTB206CA01" :value="item.SETTB206CA01">
										</el-option>
									</el-select>
								</div>
								<div class="CustomerfillingDig-tab-li-b">*必选*</div>
							</div>
							<div class="CustomerfillingDig-tab-li">
								<div class="CustomerfillingDig-tab-li-text">变动方式：</div>
								<div class="CustomerfillingDig-tab-li-ipt">
									<el-select v-model="wayTypeValue" disabled placeholder="请选择">
										<el-option v-for="item in wayTypeOptions" :key="item.value" :label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</div>
								<div class="CustomerfillingDig-tab-li-b">*必选*</div>
							</div>
							<div class="CustomerfillingDig-tab-li">
								<div class="CustomerfillingDig-tab-li-text">余额：</div>
								<div class="CustomerfillingDig-tab-li-ipt">{{cusUpdateObj.ORMTB410CA03}}</div>
								<div class="CustomerfillingDig-tab-li-b">*必填*</div>
							</div>
							<div class="CustomerfillingDig-tab-li">
								<div class="CustomerfillingDig-tab-li-text">充值金额：</div>
								<div class="CustomerfillingDig-tab-li-ipt">
									<input ref="topMoney" type="text" v-model="CZmoney" :maxlength="Czmaxlength"
										@input="topMoneyInput" @change="topMoneyChange">
								</div>
								<div class="CustomerfillingDig-tab-li-b">*必填*</div>
							</div>
							<div class="CustomerfillingDig-tab-li" v-if="RechargetypeValue =='财务（返现，欠账）'">
								<div class="CustomerfillingDig-tab-li-text">备注：</div>
								<div class="CustomerfillingDig-tab-li-ipt">
									<input type="text" v-model="CZremark" maxlength="100">
								</div>
								<div class="CustomerfillingDig-tab-li-b">*必填*</div>
							</div>
							<div class="CustomerfillingDig-priceNumtext">
								金额大写：<span>{{amountCapitalText}}</span>
							</div>
							<div class="CustomerfillingDig-tab-btn">
								<el-button type="primary" @click="CZserve()">保存</el-button>
								<el-button type="warning" @click="CustomerfillingDig=false">取消</el-button>
							</div>
						</div>
					</div>
				</el-dialog>
			</div>
			<div class="public-dialog">
				<!-- wayTypeValue='' -->
				<el-dialog title="红冲" :visible.sync="HCshow" width="40%"
					@close="HCObj='',HCmoney='',HCamountCapitalText=''" :closeOnClickModal='false' append-to-body custom-class="sales-bill-dialog">
					<div style="max-height: 500px;overflow-y: auto;">
						<div class="CustomerfillingDig-tab">
							<div class="CustomerfillingDig-tab-li">
								<div class="CustomerfillingDig-tab-li-text">客户名称：</div>
								<div class="CustomerfillingDig-tab-li-ipt">{{cusUpdateObj.ORMTB410CA00}}</div>
								<div class="CustomerfillingDig-tab-li-b"></div>
							</div>
							<div class="CustomerfillingDig-tab-li">
								<div class="CustomerfillingDig-tab-li-text">余额：</div>
								<div class="CustomerfillingDig-tab-li-ipt">{{cusUpdateObj.ORMTB410CA03}}</div>
								<div class="CustomerfillingDig-tab-li-b"></div>
							</div>
							<div class="CustomerfillingDig-tab-li">
								<div class="CustomerfillingDig-tab-li-text">红冲金额：</div>
								<div class="CustomerfillingDig-tab-li-ipt">
									<input ref="HCmoney" type="text" v-model="HCmoney" maxlength="12"
										@input="HCMoneyInput" @change="HCMoneyChange">
								</div>
								<div class="CustomerfillingDig-tab-li-b">*必填*</div>
							</div>
							<div class="CustomerfillingDig-tab-li">
								<div class="CustomerfillingDig-tab-li-text">备注：</div>
								<div class="CustomerfillingDig-tab-li-ipt">
									<input type="text" v-model="HCremark" maxlength="100">
								</div>
								<div class="CustomerfillingDig-tab-li-b">*必填*</div>
							</div>
							<div class="CustomerfillingDig-priceNumtext">
								金额大写：<span>{{HCamountCapitalText}}</span>
							</div>
							<div class="CustomerfillingDig-tab-btn">
								<el-button type="primary" @click="HCserve()">确认</el-button>
								<el-button type="warning" @click="HCshow=false">取消</el-button>
							</div>
						</div>
					</div>
				</el-dialog>
			</div>
			<div class="public-dialog">
				<el-dialog title="充值优惠记录" :visible.sync="preferentialRecord"
					@close="upCusClose,CZRecordsPage=1,CZRecordsPageLimit=10,CZRecordsCount=0,page=1" width="90%"
					:closeOnClickModal='false' append-to-body custom-class="sales-bill-dialog">
					<div style="max-height: 500px;overflow-y: auto;">
						<div class="salesWatersStatisticsPC-saleWaterDetails-table pulbic_table_container">
							<el-table :data="CZRecordsDetails" style="width: 100%" stripe class="public_tableColumn"
								:header-cell-style="{'font-family':'Microsoft YaHei','font-weight':'bold',color:'rgba(51,51,51,1)'}">
								<el-table-column prop="ORMTB410CA00" label="客户名称">
								</el-table-column>
								<el-table-column prop="ORMTB411CA03" label="充值时间">
								</el-table-column>
								<el-table-column prop="ORMTB411CA04" label="充值类型">
								</el-table-column>
								<el-table-column prop="ORMTB411CA00" label="充值金额">
								</el-table-column>
								<el-table-column prop="ORMTB411CA01" label="剩余金额">
								</el-table-column>
								<!-- <el-table-column prop="" label="在线类型">
								</el-table-column> -->
								<!-- <el-table-column prop="" label="优惠类型">
								</el-table-column> -->
								<!-- <el-table-column prop="" label="价格区间">
								</el-table-column> -->
								<el-table-column prop="ORMTB411CA02" label="充值人">
								</el-table-column>
								<el-table-column label="操作">
									<template slot-scope="scope">
										<el-button class="public_icon_chongzhi public_icon_width public_icon_margin"
											type="primary" size="small" @click="HCclick(scope.row),HCshow=true"
											id="优惠明细">红冲
										</el-button>
										<el-button class="public_icon_chongzhi public_icon_width public_icon_margin"
											type="primary" size="small" @click="offerDetailsClick(scope.row)" id="优惠明细">
											优惠明细</el-button>
										<el-button class="public_icon_chongzhi public_icon_width public_icon_margin"
											type="primary" size="small"
											@click="deductionRecordClick(scope.row),deductionRecord=true" id="变动记录">变动记录
										</el-button>
									</template>
								</el-table-column>
							</el-table>
						</div>
						<div class="billOperationRecord-page">
							<el-pagination @size-change="CZRecordsSizeChange" @current-change="CZRecordsCurrentChange"
								:current-page.sync="CZRecordsPage" :page-sizes="[10, 20, 30, 40]"
								:page-size="CZRecordsPageLimit" layout="total,sizes, prev, pager, next, jumper"
								:total="CZRecordsCount">
							</el-pagination>
						</div>
					</div>
				</el-dialog>
			</div>
			<div class="public-dialog">
				<el-dialog title="优惠明细" :visible.sync="offerDetails" width="30%" :closeOnClickModal='false' append-to-body custom-class="sales-bill-dialog">
					<el-table :data="offerDetailsTab" style="width: 100%" stripe class="public_tableColumn"
						:header-cell-style="{'font-family':'Microsoft YaHei','font-weight':'bold',color:'rgba(51,51,51,1)'}">
						<el-table-column prop="SETTB99CA00" label="关联厂区">
						</el-table-column>
						<el-table-column prop="ORMTB412CA01" label="优惠方式">
						</el-table-column>
						<el-table-column prop="ORMTB412CA00" label="优惠金额">
						</el-table-column>
					</el-table>
				</el-dialog>
			</div>
			<div class="public-dialog">
				<el-dialog title="变动记录" :visible.sync="deductionRecord" width="70%"
					@close="ORMTB411ID='',deductionRecordPage=1,deductionRecordLimit=10,deductionRecordCount=0"
					:closeOnClickModal='false' append-to-body custom-class="sales-bill-dialog">
					<el-table :data="deductionRecordtable" style="width: 100%" stripe class="public_tableColumn"
						:header-cell-style="{'font-family':'Microsoft YaHei','font-weight':'bold',color:'rgba(51,51,51,1)'}">
						<el-table-column prop="ORMTB413CA01" label="扣费时间">
						</el-table-column>
						<el-table-column prop="ORMTB440CA00" label="派单号">
						</el-table-column>
						<!-- <el-table-column prop="" label="客户名称">
						</el-table-column> -->
						<!-- <el-table-column prop="" label="扣前金额">
						</el-table-column> -->
						<el-table-column prop="ORMTB413CA00" label="扣款金额">
						</el-table-column>
						<el-table-column prop="ORMTB413CA02" label="变动类型">
						</el-table-column>
						<!-- <el-table-column prop="" label="扣后金额">
						</el-table-column> -->
						<el-table-column prop="" label="操作">
							<template slot-scope="scope">
								<el-button v-if="scope.row.ORMTB413CA02!='红冲'"
									class="public_icon_chongzhi public_icon_width public_icon_margin" type="primary"
									size="small" @click="DetailsWaterClick(scope.row)" id="详情">详情</el-button>
							</template>

						</el-table-column>
					</el-table>
					<div class="billOperationRecord-page">
						<el-pagination @size-change="deductionRecordSizeChange"
							@current-change="deductionRecordCurrentChange" :current-page.sync="deductionRecordPage"
							:page-sizes="[10, 20, 30, 40]" :page-size="deductionRecordLimit"
							layout="total,sizes, prev, pager, next, jumper" :total="deductionRecordCount">
						</el-pagination>
					</div>
				</el-dialog>
			</div>
			<div class="public-dialog">
				<el-dialog title="详情" :visible.sync="DetailsWater" width="30%" :closeOnClickModal='false' append-to-body custom-class="sales-bill-dialog">
					<div class="DetailsWater-Dialog">
						<div class="DWD-li">
							<div class="DWD-li-title">流水号</div>
							<div class="DWD-li-text">{{deductionRecordObj.ORMTB440CA00||''}}</div>
						</div>
						<div class="DWD-li">
							<div class="DWD-li-title">企业名称</div>
							<div class="DWD-li-text">{{deductionRecordObj.ORMTB440CA05||''}}</div>
						</div>
						<div class="DWD-li">
							<div class="DWD-li-title">客户名称</div>
							<div class="DWD-li-text">{{deductionRecordObj.ORMTB440CA03||''}}</div>
						</div>
						<div class="DWD-li">
							<div class="DWD-li-title">车牌号</div>
							<div class="DWD-li-text">{{deductionRecordObj.ORMTB440CA01||''}}</div>
						</div>
						<div class="DWD-li">
							<div class="DWD-li-title">派单时间</div>
							<div class="DWD-li-text">{{deductionRecordObj.ORMTB440CA19||''}}</div>
						</div>
						<div class="DWD-li">
							<div class="DWD-li-title">结算时间</div>
							<div class="DWD-li-text">{{deductionRecordObj.ORMTB440CC00||''}}</div>
						</div>
						<div class="DWD-li">
							<div class="DWD-li-title">回执时间</div>
							<div class="DWD-li-text">{{deductionRecordObj.ORMTB440CE00||''}}</div>
						</div>
						<div class="DWD-table">
							<div class="DWD-table-left-title">
								<div></div>
								<div>派单</div>
								<div>结算</div>
								<div>回执</div>
							</div>
							<div class="DWD-table-left-flex">
								<div>物料</div>
								<div>{{deductionRecordObj.ORMTB440CA07||''}}</div>
								<div>{{deductionRecordObj.ORMTB440CC02||''}}</div>
								<div></div>
							</div>
							<div class="DWD-table-left-flex">
								<div>重量</div>
								<div>{{deductionRecordObj.ORMTB440CA10||0}}</div>
								<div>{{deductionRecordObj.ORMTB440CC04||0}}</div>
								<div v-if="deductionRecordObj.ORMTB440CF01=='5'">{{deductionRecordObj.ORMTB440CE09||0}}
								</div>
								<div v-else></div>
							</div>
							<div class="DWD-table-left-flex">
								<div>物料金额</div>
								<div>{{deductionRecordObj.ORMTB440CA11||0}}</div>
								<div>{{deductionRecordObj.ORMTB440CC06||0}}</div>
								<div></div>
							</div>
							<div class="DWD-table-left-flex">
								<div>运费金额</div>
								<div>{{deductionRecordObj.ORMTB440CA12||0}}</div>
								<div>{{deductionRecordObj.jsORMTB440CA12||0}}</div>
								<div v-if="deductionRecordObj.ORMTB440CF01=='5'">{{deductionRecordObj.ORMTB440CE10||0}}
								</div>
								<div v-else></div>
							</div>
						</div>
					</div>
					<div class="DetailsWater-img">
						<div class="DetailsWater-img-text">回执记录</div>
						<el-image style="width: 80px; height: 80px" :src="DetailsWaterurl"
							:preview-src-list="DetailsWatersrcList">
						</el-image>
					</div>
				</el-dialog>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		Decimal
	} from 'decimal.js';
	export default {
		data() {
			return {
				customerManagementList: '',
				customerManagementValue: '',
				customerManagement: false,
				customerManagementAdd: false,
				customerManagementAddName: '',
				customerManagemenUPObj: '',
				customerManagementUpdate: false,
				cusQueryName: '',
				cusQueryiphone: '',
				options: [],
				cusStatus: '',
				cusStatusList: [],
				tableData: [],
				flag: '',
				page: 1,
				pagesize: 10,
				currentPage: 1,
				count: 0,
				currentPage1: 1,
				detailsPageLimit: 10,
				detailsCount: 1,
				RechargetypeValue: '银行卡',
				RechargetypeOptions: [],
				CZRecordsDetails: [],
				CZRecordsPage: 1,
				CZRecordsPageLimit: 10,
				CZRecordsCount: 0,
				tableDataDetails: [],
				offerDetailsTab: [],
				ORMTB411ID: '',
				CustomerfillingDig: false,
				wayTypeValue: '',
				wayTypeOptions: [{
						value: 'CW',
						label: '财务'
					},
					{
						value: 'XX',
						label: '线下'
					},
					{
						value: 'XS',
						label: '线上'
					},
				],
				khdj: '',
				khdjOperation: [{
					value: '',
					label: '全部',
				}, {
					value: '0301',
					label: '一级客户',
				}, {
					value: '0302',
					label: '二级客户',
				}, {
					value: '0303',
					label: '三级客户',
				}, {
					value: '0304',
					label: '四级客户',
				}, {
					value: '0305',
					label: '五级客户',
				}, {
					value: '0306',
					label: '六级客户',
				}, {
					value: '0307',
					label: '七级客户',
				}, {
					value: '0308',
					label: '八级客户',
				}],
				khxj: '',
				khxjOperation: [{
					value: '',
					label: '全部',
				}, {
					value: '1',
					label: 'V1',
				}, {
					value: '2',
					label: 'V2',
				}, {
					value: '3',
					label: 'V3',
				}, {
					value: '4',
					label: 'V4',
				}, {
					value: '5',
					label: 'V5',
				}],
				CZmoney: '',
				Czmaxlength: 10, //充值限额
				CZremark:'',
				HCmoney: '',
				HCremark: '',
				HCamountCapitalText: '',
				amountCapitalText: '',
				cusInsertShow: false,
				cusInsertObj: {
					ORMTB400ID: '',
					ORMTB410CA00: '',
					ORMTB410CA01: '',
					ORMTB410CA02: '',
					ORMTB410CA06: ''
				},
				cusUpdateShow: false,
				cusUpdateObj: {
					ORMTB400ID: '',
					ORMTB410CA00: '',
					ORMTB410CA01: '',
					ORMTB410CA02: '',
					ORMTB410CA06: ''
				},
				cusDJSetObj:{},
				freezeInsertShow: false,
				saleWaterDetails: false,
				rechargeTypeDig: false,
				rechargeTypeName: '',
				rechargeTypeUpOBJ: {
					SETTB206CA01: ''
				},
				rechargeTypeModifyDig: false,
				czRechargetypeShow: false,
				HCshow: false,
				HCObj: '',
				preferentialRecord: false,
				offerDetails: false,
				DetailsWater: false,
				deductionRecord: false,
				deductionRecordObj: '',
				deductionRecordtable: [],
				deductionRecordPage: 1,
				deductionRecordLimit: 10,
				deductionRecordCount: 0,
				DetailsWaterurl: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
				DetailsWatersrcList: [
					'https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg',
					'https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg'
				],
				preferentialType: 0,
				solelist: [],
				cusUDJSetpdateShow:false,
				tableDataGradePre: []
			};
		},
		created() {
			var list = "";
			if (this.$route.query.mark != "" && this.$route.query.mark != null) {
				this.userobj = JSON.parse(sessionStorage.getItem("qpUobj"));
				list = JSON.parse(sessionStorage.getItem("qpSolelist"));
				sessionStorage.removeItem('qpUobj');
				sessionStorage.removeItem('qpSolelist');
				this.quanpDisabled = true;
			} else {
				this.userobj = this.$store.state.uobj;
				list = this.$store.state.solelist;
				this.quanpDisabled = false;
			}
			var path = this.$route.path;
			if (path === "/SalesCustomer") {
				path = "/Home" + path;
			}
			this.solelist = this.$baseAPI.querSoleList(list, path); //获取权限列表
			// console.log(this.solelist)
			// 赋值，缓存销毁
			this.historyInfo = JSON.parse(sessionStorage.getItem(this.currentUrl));
			sessionStorage.removeItem(this.currentUrl);
			if (this.historyInfo != null && this.historyInfo != "") {
				this.init();
			}
			// console.log(this.solelist)
			this.wayTypeValue = this.wayTypeOptions[0].value
		},
		mounted() {
			this.querycusList()
			this.querypreferentialCode()
		},
		// 存储数据
		beforeDestroy() {
			var obj = {
				cusQueryName: this.cusQueryName, //客户名称
				cusQueryiphone: this.cusQueryiphone, //客户名称
				cusStatus: this.cusStatus, //客户状态
				currentPage: this.currentPage, //当前页数
				page: this.page, //页码
				pagesize: this.pagesize, //每页条数
			};
			sessionStorage.setItem(this.currentUrl, JSON.stringify(obj));
		},
		methods: {

			onSortChange({
				prop,
				order
			}) {
				console.log(order)
				if (prop == 'ORMTB410CA06') {
					this.tableData.sort(this.compare(prop, order));
				}

			},
			compare(propertyName, sort) {
				return function(obj1, obj2) {
					var value1 = obj1[propertyName];
					var value2 = obj2[propertyName];
					console.log(value2)

					if (typeof value1 === "string" && typeof value2 === "string") {
						const res = value1.localeCompare(value2);
						return sort === "ascending" ? res : -res;
					} else {
						// if (value1 <= value2) {
						// 	return sort === "ascending" ? -1 : 1;
						// } else if (value1 > value2) {
						// 	return sort === "ascending" ? 1 : -1;
						// }
					}
				};
			},


			// 账号的启用和禁用
			updateUserStatus(item) {
				var url = "/orm/ormtb410/updateUserStatus"
				var postData = {
					ORMTB410ID: item.ORMTB410ID,
					ORMTB410CA02: item.ORMTB410CA02, // 手机号
					ORMTB410CB00: item.ORMTB410CB00 == 1 ? '0' : '1', //状态 启用传1，禁用传0
				}
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.querycusList()
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			},

			// 下单的限制和解除限制
			updateUserLimitStatus(item) {
				var url = "/orm/ormtb410/updateORMTB410CB01"
				var postData = {
					ORMTB410ID: item.ORMTB410ID,
					// ORMTB410CA02: item.ORMTB410CA02, // 手机号
					ORMTB410CB01: item.ORMTB410CB01 == 1 ? '0' : '1', //状态 启用传1，禁用传0
				}
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.querycusList()
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			},

			//初始化数据
			init() {
				this.cusQueryName = this.historyInfo.cusQueryName;
				this.cusQueryiphone = this.historyInfo.cusQueryiphone;
				this.currentPage = this.historyInfo.currentPage;
				this.page = this.historyInfo.page;
				this.pagesize = this.historyInfo.pagesize;
				this.cusStatus = this.historyInfo.cusStatus
			},
			fullScreen() {
				//全屏
				var mark = 1;
				sessionStorage.setItem(
					"qpSolelist",
					JSON.stringify(this.$store.state.solelist)
				);
				sessionStorage.setItem("qpUobj", JSON.stringify(this.$store.state.uobj));

				let Logistics = this.$router.resolve({
					path: "/SalesCustomer",
					query: {
						mark: mark,
					},
				});
				this.$baseAPI.requestFullScreen(Logistics);
			},
			querycusList(dataFlag) {
				this.tableData = []
				this.flag = dataFlag
				// this.count =0
				var url = "/orm/ormtb410/selectPageList"
				if (dataFlag) {
					this.page = ''
					this.pagesize = ''
				}
				var postData = {
					ORMTB400ID: this.userobj.ormtb400.ORMTB400ID,
					ORMTB410CA00: this.cusQueryName, //客户名称
					ORMTB410CA02: this.cusQueryiphone, //客户手机号
					ORMTB410CA06: this.khdj, //客户等级
					ORMTB410CB02: this.khxj, //客户星级
					flag: dataFlag, //查询所有客户全部展示
					page: this.page,
					limit: this.pagesize
				}
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.tableData = res.data.data;
						this.count = res.data.count;

					}
					if (this.tableData.length > 0) {
						setTimeout(() => {
							loading.close()
						}, 300)
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)

				}).catch(() => {
					loading.close()
				})
			},
			freezeSetClick() {
				this.freezeInsertShow = true
				this.cusSelect()
			},
			cusSelect(){
				var url = "/orm/ormtb405/select"
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				this.axios.post(url).then(res => {
					console.log(res)
					if (res.data.code == 200) {
						this.tableDataGradePre = res.data.data;
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			},
			handleSizeChange(val) {
				this.pagesize = val;
				this.page = 1;
				this.querycusList();
			},
			handleCurrentChange(val) {
				this.page = val;
				this.querycusList();
			},
			CZrecordClick(row) {
				// console.log(row)
				this.preferentialRecord = true
				var str = JSON.stringify(row)
				this.cusUpdateObj = JSON.parse(str)
				this.CZrecordQuery()
			},
			CZrecordQuery() {
				this.CZRecordsDetails = []
				// this.CZRecordsCount =0
				var url = "/orm/ormtb411/selectPageList"
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					ORMTB410ID: this.cusUpdateObj.ORMTB410ID,
					page: this.CZRecordsPage,
					limit: this.CZRecordsPageLimit
				}
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.CZRecordsDetails = res.data.data;
						this.CZRecordsCount = res.data.count;
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			},
			offerDetailsClick(row) {
				this.offerDetails = true
				this.offerDetailsTab = []
				var url = "/orm/ormtb412/selectList"
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					ORMTB411ID: row.ORMTB411ID,
					SETTB206CD01: this.userobj.pertb005.pertb005cd01,
				}
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.offerDetailsTab = res.data.data;
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			},
			deductionRecordClick(row) {
				this.deductionRecordtable = []
				// this.deductionRecordCount=0
				var url = "/orm/ormtb413/selectPageList"
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				this.ORMTB411ID = row.ORMTB411ID
				var postData = {
					ORMTB411ID: this.ORMTB411ID,
					page: this.deductionRecordPage,
					limit: this.deductionRecordLimit
				}
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.deductionRecordtable = res.data.data;
						this.deductionRecordCount = res.data.count
						this.deductionRecordtable.forEach(item => {
							if (item.ORMTB413CA02 == 'KK') {
								item.ORMTB413CA02Text = "扣款"
							} else if (item.ORMTB413CA02 == 'TK') {
								item.ORMTB413CA02Text = "退款"
							}
						})
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			},
			deductionRecordSizeChange(val) {
				this.deductionRecordLimit = val;
				this.deductionRecordPage = 1;
				this.deductionRecordClick();
			},
			deductionRecordCurrentChange(val) {
				this.deductionRecordPage = val;
				this.deductionRecordClick();
			},
			queryWayTypeQuery() {
				this.tableDataDetails = []
				// this.detailsCount=0
				var url = "/set/settb206/selectPageList"
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					SETTB206CD01: this.userobj.ormtb400.ORMTB400CA03,
					SETTB205ID: '01',
					page: this.currentPage1,
					limit: this.detailsPageLimit
				}
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.tableDataDetails = res.data.data;
						this.detailsCount = res.data.count
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			},
			handleSizeChange1(val) {
				this.detailsPageLimit = val;
				this.currentPage1 = 1;
				this.deductionRecordClick();
			},
			handleCurrentChange1(val) {
				this.currentPage1 = val;
				this.deductionRecordClick();
			},
			saleWaterDetailsclose() {

			},
			CustomerfillingDigClose() {

			},
			cusInsertClose() {
				this.cusInsertObj = {
					ORMTB400ID: '',
					ORMTB410CA00: '',
					ORMTB410CA01: '',
					ORMTB410CA02: '',
					ORMTB410CA06: ''
				}
			},
			cusInsertServe() {
				if (this.cusInsertObj.ORMTB410CA00.trim().length == 0) return this.$message.error('请输入客户名称')
				var reQ = /^1[3-9][0-9]{9}$/;
				if (!reQ.test(this.cusInsertObj.ORMTB410CA02)) return this.$message.error('请输入有效手机号')
				if (this.preferentialType == 1) {
					if (this.cusInsertObj.ORMTB410CA06.length == 0) {
						return this.$message.error('请选择客户等级')
					}
				}
				var url = "/orm/ormtb410/insertOrmtb410"
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = this.cusInsertObj
				postData.ORMTB400ID = this.userobj.ormtb400.ORMTB400ID
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.$message.success('新增成功')
						this.querycusList()
						this.cusInsertShow = false
						this.cusInsertObj = {
							ORMTB400ID: '',
							ORMTB410CA00: '',
							ORMTB410CA01: '',
							ORMTB410CA02: '',
							ORMTB410CA06: '',
						}
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			},
			cusDJSetInsertServe(){
				var url="/orm/ormtb405/update"
				var settb400List=[]
				
				this.tableDataGradePre.forEach((resitme) => {
					settb400List.push(resitme)
					
				})
				var postData = {
					list:settb400List,
				}
				var loading=this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				this.axios.post(url, postData).then(res => {
					console.log(res)
					if (res.data.code == 200) {
						this.querycusList()
						this.$message({
							message: '提交成功',
							type: 'success'
						});
						this.freezeInsertShow = false
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(()=>{
						loading.close()
					},300)
				}).catch(()=>{
					loading.close()
				})
			},
			upCusClose() {
				this.cusUpdateObj = {
					ORMTB400ID: '',
					ORMTB410CA00: '',
					ORMTB410CA01: '',
					ORMTB410CA02: '',
					ORMTB410CA06: ''
				}
				this.CZmoney = ''
				this.wayTypeValue = 'CW'
				this.amountCapitalText = ''
			},
			CZTypeQuery() {
				this.RechargetypeOptions = []
				var url = "/orm/ormtb411/selectCzType/" + this.userobj.ormtb400.ORMTB400CA03
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				this.axios.get(url).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.RechargetypeOptions = res.data.data
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			},
			czClick(row) { //点击充值
				this.CustomerfillingDig = true
				var str = JSON.stringify(row)
				this.cusUpdateObj = JSON.parse(str)
				// this.RechargetypeValue = "银行卡"
				this.CZTypeQuery()
			},
			CZserve() {
				if (this.RechargetypeValue == '') return this.$message.error('请选择充值类型')
				if (this.wayTypeValue == '') return this.$message.error('请选择变动方式')
				if (this.CZmoney <= 0) return this.$message.error('请输入充值金额')
				
				if(this.RechargetypeValue=='财务（返现，欠账）'){
					if(!this.CZremark){
						this.$message.error('请填写备注')
					}
					
				}
				var url = "/orm/ormtb411/cz"
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					ORMTB410ID: this.cusUpdateObj.ORMTB410ID,
					ORMTB420CA01: this.wayTypeValue,
					ORMTB420CA02: this.CZmoney,
					ORMTB420CB01:this.CZremark,
					ORMTB411CA04: this.RechargetypeValue
				}
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.$message.success('充值成功')
						this.querycusList()
						this.CustomerfillingDig = false
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			},
			HCclick(row) { //点击红冲
				var str = JSON.stringify(row)
				this.cusUpdateObj = JSON.parse(str)
				this.HCshow = true
			},

			HCserve() {
				if (!this.HCmoney) return this.$message.error('请输入红冲金额');
				if (!this.HCremark) return this.$message.error('请输入备注');
				// if (this.HCmoney > this.cusUpdateObj.ORMTB410CA03) return this.$message.error('红冲金额不可大于余额');
				var url = "/orm/ormtb411/hc"
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					ORMTB410ID: this.cusUpdateObj.ORMTB410ID,
					ORMTB420CA02: this.HCmoney,
					ORMTB420CA08: this.HCremark
				}
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.$message.success(`红冲成功`)
						this.HCshow = false
						this.querycusList()
						this.HCremark = ''
						this.HCmoney = ''
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			},
			upuserClick(row) {
				if (this.preferentialType == 1) {
					this.customerManagementQuery()
				}
				this.cusUpdateShow = true
				var str = JSON.stringify(row)
				this.cusUpdateObj = JSON.parse(str)
			},
			upDJSetuserClick(row){
				this.cusUDJSetpdateShow = true
				var str = JSON.stringify(row)
				this.cusDJSetObj = JSON.parse(str)
				console.log(this.cusDJSetObj)
			},
			cusADD() {
				if (this.preferentialType == 1) {
					this.customerManagementQuery()
				}
				this.cusInsertShow = true
			},
			cusUpdateServe() {
				if (this.cusUpdateObj.ORMTB410CA00.trim().length == 0) return this.$message.error('请输入客户名称')
				var reQ = /^1[3-9][0-9]{9}$/;
				if (!reQ.test(this.cusUpdateObj.ORMTB410CA02)) return this.$message.error('请输入有效手机号')
				if (this.preferentialType == 1) {
					if (this.cusUpdateObj.ORMTB410CA06.length == 0) {
						return this.$message.error('请选择客户等级')
					}
				}
				var url = "/orm/ormtb410/updateOrmtb410ById"
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = this.cusUpdateObj
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.$message.success('修改成功')
						this.querycusList()
						this.cusUpdateShow = false
						this.cusUpdateObj = {
							ORMTB400ID: '',
							ORMTB410CA00: '',
							ORMTB410CA01: '',
							ORMTB410CA02: '',
							ORMTB410CA06: ''
						}
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			},
			cusDJSetdateServe(){
				
				if (!this.cusDJSetObj.ORMTB410CB07) return this.$message.error('请输入冻结倍数')
				
				var url = "/orm/ormtb410/updateORMTB410CB07"
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				
				var postData = {
					ORMTB410ID:this.cusDJSetObj.ORMTB410ID,
					ORMTB410CB07:this.cusDJSetObj.ORMTB410CB07
				}
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.$message.success('设置成功')
						this.querycusList()
						this.cusUDJSetpdateShow = false
						
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			},
			rechargeTypeModify(row) {
				this.rechargeTypeModifyDig = true
				var str = JSON.stringify(row)
				this.rechargeTypeUpOBJ = JSON.parse(str)
			},
			disableCus(row, type) {
				var str = type == 1 ? '启用' : '禁用'
				this.$confirm(`此操作将${str}该条数据, 是否继续?`, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					var url = "/orm/ormtb410/updataCzType"
					var loading = this.$loading({
						lock: true,
						text: '请求中...',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.5)'
					});
					// console.log(this.userobj)
					var postData = {
						SETTB206CA01: '',
						SETTB206ID: row.SETTB206ID,
						SETTB206CA02: type,
					}
					this.axios.post(url, postData).then(res => {
						// console.log(res)
						if (res.data.code == 200) {
							this.$message.success(`${str}成功`)
							this.queryWayTypeQuery()
						} else {
							this.$message({
								message: res.data.message,
								type: 'error'
							});
						}
						setTimeout(() => {
							loading.close()
						}, 300)
					}).catch(() => {
						loading.close()
					})
				})
			},
			rechargeTypeAdd() {
				this.rechargeTypeDig = true
			},
			rechargeTypeModifyClose() {
				this.rechargeTypeUpOBJ = {
					SETTB206CA01: ''
				}
			},
			querypreferentialCode() {
				var url = "/set/settb206/selectSETTB206List "
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					"SETTB205ID": "02", //默认02
					"SETTB206CA00": "0202", //代码值默认0202
					"SETTB206CD01": this.userobj.ormtb400.ORMTB400CA03 //一级客户代码
				}
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.preferentialType = res.data.data[0].SETTB206CA02
						// 	loading.close()
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			},
			customerManagementQuery() {
				this.customerManagementList = []
				var url = "/set/settb206/selectPerson/" + this.userobj.ormtb400.ORMTB400CA03
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				this.axios.get(url).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.customerManagementList = res.data.data
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			},
			customerManagementAddServe() {
				if (this.customerManagementAddName.trim().length == 0) return this.$message.error('请输入名称')
				var url = "/set/settb206/insertVIP "
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				// console.log(this.userobj)
				var postData = {
					SETTB206CA01: this.customerManagementAddName,
					SETTB206CD01: this.userobj.ormtb400.ORMTB400CA03,
					ORMTB400ID: this.userobj.ormtb400.ORMTB400ID
				}
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.$message.success('新增成功')
						this.customerManagementQuery()
						this.customerManagementAdd = false
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			},
			cusUpdataClick(row) {
				this.customerManagemenUPObj = row
				this.customerManagemenUPObj.oldname = row.SETTB206CA01
				this.customerManagementUpdate = true
			},
			customerManagementUpdateServe() {
				if (this.customerManagemenUPObj.oldname == this.customerManagemenUPObj.SETTB206CA01) return this.$message
					.error('请修改名称')
				if (this.customerManagemenUPObj.SETTB206CA01.trim().length == 0) return this.$message.error('请输入名称')
				var url = "/set/settb206/updateVIP"
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					SETTB206CA01: this.customerManagemenUPObj.SETTB206CA01,
					SETTB206ID: this.customerManagemenUPObj.SETTB206ID,
				}
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.$message.success('修改成功')
						this.customerManagementQuery()
						this.customerManagementUpdate = false
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			},
			rechaTypePreser() {
				if (this.rechargeTypeName.trim().length == 0) return this.$message.error('请输入名称')
				var url = "/orm/ormtb410/addCzType"
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				// console.log(this.userobj)
				var postData = {
					SETTB206CA01: this.rechargeTypeName,
					SETTB206CD01: this.userobj.ormtb400.ORMTB400CA03
				}
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.$message.success('新增成功')
						this.queryWayTypeQuery()
						this.rechargeTypeDig = false
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			},
			rechaTypePreserModify() {
				if (this.rechargeTypeUpOBJ.SETTB206CA01.trim().length == 0) return this.$message.error('请输入名称')
				var url = "/orm/ormtb410/updataCzType"
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				// console.log(this.userobj)
				var postData = {
					SETTB206CA01: this.rechargeTypeUpOBJ.SETTB206CA01,
					SETTB206ID: this.rechargeTypeUpOBJ.SETTB206ID,
					SETTB206CA02: this.rechargeTypeUpOBJ.SETTB206CA02,
					SETTB206CD01: this.userobj.ormtb400.ORMTB400CA03
				}
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.$message.success('修改成功')
						this.queryWayTypeQuery()
						this.rechargeTypeModifyDig = false
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			},
			DetailsWaterClick(item) {
				// console.log(item)
				if (!item.ORMTB440CA00) {
					this.$message({
						message: '未查询到订单',
						type: 'error'
					});
					return
				}
				this.DetailsWater = true
				this.deductionRecordDetileQuery(item)
			},
			deductionRecordDetileQuery(row) {
				this.deductionRecordObj = ''
				this.DetailsWatersrcList = []
				this.DetailsWaterurl = ''
				var url = "/orm/ormtb440/selectDetails"
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				// console.log(this.userobj)
				var postData = {
					ORMTB440ID: row.ORMTB413CA03,
				}
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.deductionRecordObj = res.data.data
						this.DetailsWatersrcList = [this.deductionRecordObj.ORMTB440CE01]
						this.DetailsWaterurl = this.deductionRecordObj.ORMTB440CE01
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			},
			CZRecordsSizeChange(val) {
				this.pagesize = val;
				this.page = 1;
				this.CZrecordQuery();
			},
			CZRecordsCurrentChange(val) {
				this.page = val;
				this.CZrecordQuery();
			},

			HCMoneyInput() {
				this.HCmoney = this.HCmoney.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
				this.HCmoney = this.HCmoney.replace(/^\./g, ""); //验证第一个字符是数字
				this.HCmoney = this.HCmoney.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
				this.HCmoney = this.HCmoney.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
				this.HCmoney = this.HCmoney.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); //只能输入两个小数
				if (this.HCmoney.indexOf(".") < 0 && this.HCmoney != "") { //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
					this.HCmoney = parseFloat(this.HCmoney);
				}
				this.HCmoney = this.HCmoney > 10000000 ? 10000000 : this.HCmoney
				this.$refs.HCmoney.value = this.HCmoney
				this.HCamountCapitalText = this.priceChange(this.HCmoney)
			},
			HCMoneyChange() {
				var index = String(this.HCmoney).indexOf('.')
				if (index == -1) return
				var numArr = this.HCmoney.split('.')
				if (numArr[1].length == 0) {
					this.$refs.HCmoney.value = numArr[0]
					this.HCmoney = numArr[0]
				} else {
					this.$refs.HCmoney.value = numArr[0] + '.' + numArr[1]
					this.HCmoney = numArr[0] + '.' + numArr[1]
				}
			},
			topMoneyInput() { //充值金额实时校验
			console.log(this.CZmoney)
				this.CZmoney = this.CZmoney.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
				this.CZmoney = this.CZmoney.replace(/^\./g, ""); //验证第一个字符是数字
				this.CZmoney = this.CZmoney.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
				this.CZmoney = this.CZmoney.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
				this.CZmoney = this.CZmoney.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); //只能输入两个小数
				if (this.CZmoney.indexOf(".") < 0 && this.CZmoney != "") { //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
					this.CZmoney = parseFloat(this.CZmoney);
				}
				this.CZmoney = this.CZmoney > 10000000 ? 10000000 : this.CZmoney
				this.$refs.topMoney.value = this.CZmoney
				this.amountCapitalText = this.priceChange(this.CZmoney)
			},
			priceChange(number) {
				var ret = "";
				if (number != "" && number != null && number != "0") {
					var unit = "仟佰拾亿仟佰拾万仟佰拾元角分",
						str = "";
					number += "00";
					var point = number.indexOf(".");
					if (point >= 0) {
						number = number.substring(0, point) + number.substr(point + 1, 2);
					}
					unit = unit.substr(unit.length - number.length);
					for (var i = 0; i < number.length; i++) {
						str += "零壹贰叁肆伍陆柒捌玖".charAt(number.charAt(i)) + unit.charAt(i);
					}
					ret =
						str
						.replace(/零(仟|佰|拾|角)/g, "零")
						.replace(/(零)+/g, "零")
						.replace(/零(万|亿|元)/g, "$1")
						.replace(/(亿)万|(拾)/g, "$1$2")
						.replace(/^元零?|零分/g, "")
						.replace(/元$/g, "元");
				}
				return ret;
			},
			topMoneyChange() { //充值金额失去焦点数据处理
				var index = String(this.CZmoney).indexOf('.')
				if (index == -1) return
				var numArr = this.CZmoney.split('.')
				if (numArr[1].length == 0) {
					this.$refs.topMoney.value = numArr[0]
					this.CZmoney = numArr[0]
				} else {
					this.$refs.topMoney.value = numArr[0] + '.' + numArr[1]
					this.CZmoney = numArr[0] + '.' + numArr[1]
				}
			},
		}
	};
</script>

<style scoped>
	.carDialogTitle {
		font-weight: bold;
		line-height: 60px;
		color: rgb(0, 163, 255);
	}

	.customerManagementPC {
		background-color: #f3f3f3;
	}

	.customerManagementPC-select .public_oparetionBlock_Menu:first-child {
		margin-left: 0;
	}

	.customerManagementPC-btn {
		text-align: left;
		margin-bottom: 20px;
	}

	.customerManagementPC-btn i {
		margin-right: 10px;
	}

	.customerManagementPC-table {
		padding: 30px 20px 0;
	}

	.customerManagementPC-table-btn i {
		font-size: 12px;
		margin-right: 5px;
	}
	.public-chech-details-table {
		margin-top: 20px;
		max-height: 500px;
		overflow-y: auto;
	}

	.public-chech-details-table-no-text {
		line-height: 80px;
		text-align: center;
		border-bottom: 1px solid #cdcdcd;
	}

	.customerManagementPC-page {
		margin-top: 20px;
		text-align: right;
	}

	.CustomerfillingDig-priceNumtext {
		font-weight: 500;
		font-size: 18px;
		line-height: 40px;
		padding: 20px 0 20px 10px;
		color: #333;
	}

	.CustomerfillingDig-priceNumtext span {
		color: rgba(175, 181, 4, 1.0);
		margin-left: 10px;
		font-size: 20px;
	}

	.fontBlue {
		color: rgba(25, 159, 255, 1) !important;
	}

	.billOperationRecord {
		background-color: #f3f3f3;
	}

	.billOperationRecord-border {

		/* border-top: 2px solid rgba(205,205,205,.4); */
		border-top: none;
		box-sizing: border-box;
		margin-right: 40px;
	}

	.billOperationRecord th,
	.billOperationRecord td {
		text-align: center;
	}

	.customerRecharge-table {
		box-sizing: border-box;
	}

	.CustomertopUpDig-content-table-btn>.public_saleWater_lieSet {
		border-color: rgba(254, 172, 0, 1) !important;
	}

	.rechargeType-tab-btn {
		margin-top: 80px !important;
	}

	.billOperationRecord-page {
		padding-right: 40px;
		text-align: right;
		margin-top: 20px;
		padding-bottom: 20px;
	}

	.salesWatersStatisticsPC-saleWaterDetails-btn {
		margin-bottom: 20px;
	}

	.salesWatersStatisticsPC-saleWaterDetails-btn i {
		margin-right: 10px;
	}

	.el-dropdown-link {
		cursor: pointer;
	}

	.el-table--scrollable-y .el-table__body-wrapper {
		overflow: auto;
	}

	.public_tableColumn .el-table__body-wrapper {
		overflow: auto !important;
	}

	.public_icon_width {
		width: 80px;
	}

	.levelmang-title {
		display: flex;
		color: #333;
		text-align: center;
		margin-bottom: 20px;

	}

	.levelmang-title div {
		padding: 10px 20px;
		background-color: #e3e3e3;
	}

	.levelmang-title .levelmang-title-active {
		background-color: #199FFF;
		color: #FFF;
	}

	.levelmang-table {
		border: 1px solid #e3e3e3;
	}

	.levelmang-table>li {
		display: flex;
	}

	.levelmang-table-head {
		text-align: center;
		background-color: #30A8FF;
		color: #FFF;
	}

	.levelmang-table-head>div {
		height: 50px;
		line-height: 50px;
		border-left: 1px solid #e3e3e3;
		box-sizing: border-box;
		overflow: hidden;
	}

	.levelmang-table-head>div:first-child {
		border: none;
	}

	.levelmang-table-CQ {
		flex: 1;
		position: relative;
		padding: 5px 10px;
	}

	.levelmang-table-CQ-list {
		border-bottom: 1px solid #e3e3e3;
	}

	.levelmang-table-JB {
		width: 240px;
	}

	.levelmang-table-KJ,
	.levelmang-table-ZK,
	.levelmang-table-YH {
		width: 295px;
	}

	.levelmang-table-ZK input,
	.levelmang-table-YH input {
		text-align: center;
	}

	.levelmang-table-li {
		text-align: center;
	}

	.levelmang-table-li-tab-li {

		border-bottom: 1px solid #e3e3e3;
	}

	.levelmang-table-li-tab-li:last-child {
		/* border: none; */
	}

	.levelmang-table-li-tab-li>div {
		border-left: 1px solid #e3e3e3;
		padding: 0 10px;
		box-sizing: border-box;
		height: 50px;
		line-height: 50px;
		vertical-align: top;
		overflow: hidden;
	}

	.levelmang-table-li-tab-li>div>input {
		width: 100px;
		border: 1px solid #e3e3e3;
		height: 35px;
		line-height: 35px;
		border-radius: 5px;
		margin-right: 10px;
	}

	.levelmang-table-CQ>div {
		position: absolute;
		left: 50%;
		top: 50%;
		width: 100%;
		transform: translate(-50%, -50%);
	}

	.levelmang-table-li-tab-li {
		display: flex;
	}
</style>
<style>
.sales-bill-dialog {
	border-radius: var(--fszs-radius-lg);
	box-shadow: var(--fszs-shadow-lg);
	overflow: hidden;
}

.sales-bill-dialog .el-dialog__header {
	height: auto;
	line-height: normal;
	padding: 18px 54px 15px 24px;
	vertical-align: middle;
	background: linear-gradient(90deg, rgba(23, 139, 255, 0.10) 0%, rgba(23, 139, 255, 0) 42%), linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
	border-bottom: 1px solid var(--fszs-border-soft);
	color: var(--fszs-text-strong);
}

.sales-bill-dialog .el-dialog__title {
	font-size: 18px;
	font-weight: 700;
	color: #102033 !important;
}

.sales-bill-dialog .el-dialog__headerbtn {
	top: 12px;
	right: 16px;
	border-radius: 50%;
}

.sales-bill-dialog .el-dialog__headerbtn .el-dialog__close {
	vertical-align: middle;
	font-size: 18px;
	color: #55708b !important;
}
</style>
